/**
 * 订单等级（订阅档位）归一化。
 *
 * 后端 order_level 的取值：
 *   1 = 初级（Basic）
 *   2 = 高级（Extreme）
 *
 * 历史遗留：增值服务（初级 / 高级分档）上线之前，老用户买的产品包**没有分档**，
 * 这些订单的 order_level 为 null（少数情况下是字符串 'null'）。按业务约定，
 * 这类订单一律**视为 2（高级）**。
 *
 * 因此本函数只在**明确等于 1** 时返回 1，其余（null / 'null' / undefined /
 * 其他非法值）一律返回 2。
 *
 * 之所以显式归一化，而不是直接用 `Number(order_level) === 1`：
 * 后者虽然对 null 也"碰巧"得到 Extreme（Number(null) === 0），但那只是巧合，
 * 一旦有人把判断改成 `=== 2 ? 'Extreme' : 'Basic'` 就会把老用户错判成初级。
 *
 * @param {*} orderLevel - 订单接口返回的 order_level
 * @returns {1|2} 归一化后的档位
 */
export const resolveOrderLevel = orderLevel => (Number(orderLevel) === 1 ? 1 : 2)

/**
 * 是否为初级（Basic）档位。
 * 历史老用户（order_level 为 null）按高级处理，这里返回 false。
 *
 * @param {*} orderLevel - 订单接口返回的 order_level
 * @returns {boolean}
 */
export const isBasicOrderLevel = orderLevel => resolveOrderLevel(orderLevel) === 1

export default resolveOrderLevel
